// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-legend[data-v-4d3b90d6] {\n  padding-top: 20px;\n}\n@media (max-width: 600px) {\n.checkbox label[data-v-4d3b90d6] {\n    width: 100%;\n    padding: 10px 10px;\n    margin-bottom: 5px;\n    background: #eee;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    -webkit-box-shadow: 1px 1px 5px #ccc;\n    box-shadow: 1px 1px 5px #ccc;\n}\n.checkbox input[type=checkbox][data-v-4d3b90d6] {\n    position: relative;\n    margin-left: 0;\n    margin-right: 5px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
